export default __webpack_public_path__ + "static/zhan-f64c576b44a332626426b5fa79e2b373.png";